export default [
    {
        title: '(GMT-11:00) Midway Island, Samoa',
        value: 'Pacific/Midway',
    },
    {
        title: '(GMT-10:00) Hawaii-Aleutian',
        value: 'America/Adak',
    },
    {
        title: '(GMT-10:00) Hawaii',
        value: 'Etc/GMT+10',
    },
    {
        title: '(GMT-09:30) Marquesas Islands',
        value: 'Pacific/Marquesas',
    },
    {
        title: '(GMT-09:00) Gambier Islands',
        value: 'Pacific/Gambier',
    },
    {
        title: '(GMT-09:00) Alaska',
        value: 'America/Anchorage',
    },
    {
        title: '(GMT-08:00) Tijuana, Baja California',
        value: 'America/Ensenada',
    },
    {
        title: '(GMT-08:00) Pitcairn Islands',
        value: 'Etc/GMT+8',
    },
    {
        title: '(GMT-08:00) Pacific Time (US & Canada)',
        value: 'Pacific/Midway',
    },
    {
        title: '(GMT-07:00) Mountain Time (US &amp; Canada)',
        value: 'America/Denver',
    },
    {
        title: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
        value: 'America/Chihuahua',
    },
    {
        title: '(GMT-07:00) Arizona',
        value: 'America/Dawson_Creek',
    },
    {
        title: '(GMT-06:00) Saskatchewan, Central America',
        value: 'America/Belize',
    },
    {
        title: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
        value: 'America/Cancun',
    },
    {
        title: '(GMT-06:00) Easter Island',
        value: 'Chile/EasterIsland',
    },
    {
        title: '(GMT-06:00) Central Time (US & Canada)',
        value: 'America/Chicago',
    },
    {
        title: '(GMT-05:00) Cuba',
        value: 'America/Havana',
    },
    {
        title: '(GMT-05:00) Bogota, Lima, Quito, Rio Branco',
        value: 'America/Bogota',
    },
    {
        title: '(GMT-04:30) Caracas',
        value: 'America/Caracas',
    },
    {
        title: '(GMT-04:00) Santiago',
        value: 'America/Santiago',
    },
    {
        title: '(GMT-04:00) La Paz',
        value: 'America/La_Paz',
    },
    {
        title: '(GMT-04:00) Faukland Islands',
        value: 'Atlantic/Stanley',
    },
    {
        title: '(GMT-04:00) Brazil',
        value: 'America/Campo_Grande',
    },
    {
        title: '(GMT-04:00) Atlantic Time (Goose Bay)',
        value: 'America/Goose_Bay',
    },
    {
        title: '(GMT-04:00) Atlantic Time (Canada)',
        value: 'America/Glace_Bay',
    },
    {
        title: '(GMT-03:30) Newfoundland',
        value: 'America/St_Johns',
    },
    {
        title: '(GMT-03:00) UTC-3',
        value: 'America/Araguaina',
    },
    {
        title: '(GMT-03:00) Montevideo',
        value: 'America/Montevideo',
    },
    {
        title: '(GMT-03:00) Miquelon, St. Pierre',
        value: 'America/Miquelon',
    },
    {
        title: '(GMT-03:00) Greenland',
        value: 'America/Godthab',
    },
    {
        title: '(GMT-03:00) Buenos Aires',
        value: 'America/Argentina/Buenos_Aires',
    },
    {
        title: '(GMT-03:00) Brasilia',
        value: 'America/Sao_Paulo',
    },
    {
        title: '(GMT-02:00) Mid-Atlantic',
        value: 'America/Noronha',
    },
    {
        title: '(GMT-01:00) Cape Verde Is',
        value: 'Atlantic/Cape_Verde',
    },
    {
        title: '(GMT-01:00) Azores',
        value: 'Atlantic/Azores',
    },
    {
        title: '(GMT) Greenwich Mean Time : Belfast',
        value: 'Europe/Belfast',
    },
    {
        title: '(GMT) Greenwich Mean Time : Dublin',
        value: 'Europe/Dublin',
    },
    {
        title: '(GMT) Greenwich Mean Time : Lisbon',
        value: 'Europe/Lisbon',
    },
    {
        title: '(GMT) UTC',
        value: 'UTC',
    },
    {
        title: '(GMT) London, Europe',
        value: 'Europe/London',
    },
    {
        title: '(GMT) Monrovia, Reykjavik',
        value: 'Africa/Abidjan',
    },
    {
        title: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        value: 'Europe/Amsterdam',
    },
    {
        title: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague</option>',
        value: 'Europe/Belgrade',
    },
    {
        title: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
        value: 'Europe/Brussels',
    },
    {
        title: '(GMT+01:00) West Central Africa',
        value: 'Africa/Algiers',
    },
    {
        title: '(GMT+01:00) Windhoek',
        value: 'Africa/Windhoek',
    },
    {
        title: '(GMT+02:00) Beirut',
        value: 'Asia/Beirut',
    },
    {
        title: '(GMT+02:00) Cairo',
        value: 'Africa/Cairo',
    },
    {
        title: '(GMT+02:00) Gaza',
        value: 'Asia/Gaza',
    },
    {
        title: '(GMT+02:00) Harare, Pretoria',
        value: 'Africa/Blantyre',
    },
    {
        title: '(GMT+02:00) Jerusalem Or Talinn',
        value: 'Asia/Jerusalem',
    },
    {
        title: '(GMT+02:00) Minsk',
        value: 'Europe/Minsk',
    },
    {
        title: '(GMT+02:00) Syria',
        value: 'Asia/Damascus',
    },
    {
        title: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
        value: 'Europe/Moscow',
    },
    {
        title: '(GMT+03:00) Istanbul',
        value: 'Europe/Istanbul',
    },
    {
        title: '(GMT+03:00) Nairobi',
        value: 'Africa/Addis_Ababa',
    },
    {
        title: '(GMT+03:30) Tehran',
        value: 'Asia/Tehran',
    },
    {
        title: '(GMT+04:00) Abu Dhabi, Muscat',
        value: 'Asia/Dubai',
    },
    {
        title: '(GMT+04:00) Yerevan',
        value: 'Asia/Yerevan',
    },
    {
        title: '(GMT+04:30) Kabul',
        value: 'Asia/Kabul',
    },
    {
        title: '(GMT+05:00) Ekaterinburg',
        value: 'Asia/Yekaterinburg',
    },
    {
        title: '(GMT+05:00) Tashkent',
        value: 'Asia/Tashkent',
    },
    {
        title: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        value: 'Asia/Kolkata',
    },
    {
        title: '(GMT+05:45) Kathmandu',
        value: 'Asia/Katmandu',
    },
    {
        title: '(GMT+06:00) Dhaka, Bangladesh',
        value: 'Asia/Dhaka',
    },
    {
        title: '(GMT+06:00) Novosibirsk',
        value: 'Asia/Novosibirsk',
    },
    {
        title: '(GMT+06:30) Yangon (Rangoon)',
        value: 'Asia/Rangoon',
    },
    {
        title: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
        value: 'Asia/Bangkok',
    },
    {
        title: '(GMT+07:00) Krasnoyarsk',
        value: 'Asia/Krasnoyarsk',
    },
    {
        title: '(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        value: 'Asia/Hong_Kong',
    },
    {
        title: '(GMT+08:00) Irkutsk, Ulaan Bataar',
        value: 'Asia/Irkutsk',
    },
    {
        title: 'Australia/Perth',
        value: '(GMT+08:00) Perth',
    },
    {
        title: '(GMT+08:45) Eucla',
        value: 'Australia/Eucla',
    },
    {
        title: '(GMT+09:00) Osaka, Sapporo, Tokyo',
        value: 'Asia/Tokyo',
    },
    {
        title: '(GMT+09:00) Seoul',
        value: 'Asia/Seoul',
    },{
        title: '(GMT+09:00) Yakutsk',
        value: 'Asia/Yakutsk',
    },
    {
        title: '(GMT+09:30) Adelaide',
        value: 'Australia/Adelaide',
    },
    {
        title: '(GMT+09:30) Darwin',
        value: 'Australia/Darwin',
    },
    {
        title: '(GMT+10:00) Brisbane',
        value: 'Australia/Brisbane',
    },
    {
        title: '(GMT+10:00) Hobart',
        value: 'Australia/Hobart',
    },
    {
        title: '(GMT+10:00) Vladivostok',
        value: 'Asia/Vladivostok',
    },
    {
        title: '(GMT+10:30) Lord Howe Island',
        value: 'Australia/Lord_Howe',
    },
    {
        title: '(GMT+11:00) Solomon Is., New Caledonia',
        value: 'Etc/GMT-11',
    },
    {
        title: '(GMT+11:00) Magadan',
        value: 'Asia/Magadan',
    },
    {
        title: '(GMT+11:30) Norfolk Island',
        value: 'Pacific/Norfolk',
    },
    {
        title: '(GMT+12:00) Anadyr, Kamchatka',
        value: 'Asia/Anadyr',
    },
    {
        title: '(GMT+12:00) Auckland, Wellington',
        value: 'Pacific/Auckland',
    },
    {
        title: '(GMT+12:00) Fiji, Kamchatka, Marshall Is.',
        value: 'Etc/GMT-12',
    },
    {
        title: '(GMT+12:45) Chatham Islands',
        value: 'Pacific/Chatham',
    },
    {
        title: '(GMT+13:00) Nuku’alofa',
        value: 'Pacific/Tongatapu',
    },
    {
        title: '(GMT+14:00) Kiritimati',
        value: 'Pacific/Kiritimati',
    }

  ]
  